<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2022/05/30
    // Modificado por: 
    // Fecha de ultima Modificacion:    2023/01/15
    // Causa: 
    ///////////////////////////////////////////////////////////
-->
<template>
  <div>
    <!-- Agregar PreguntaS -->

    <v-form ref="formdatos" lazy-validation>
      <ComunDialogComp v-model="estadoComp" max-width="500px" :title="formTitle" @close-modal="CloseComp()">
        <template v-slot:body>
          <div class="py-3 text-center">
            <v-chip class="primary">Unidad: {{ unidad.nombre_tema }}</v-chip>
          </div>

          <div class="py-3 text-center">
            <v-text-field v-model="formClase.nombre_clase" label="Nombre del tema"
              :rules="[rul.required]"></v-text-field>
            <v-text-field type="number" label="Orden" min="0" v-model="formClase.orden_clase"
              :rules="[rul.required]"></v-text-field>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="SaveItem()" :disabled="loading"
            :text-button="parametros.evento == 'edit' ? 'Guardar cambios' : 'Guardar'" icon-but="fas fa-save"
            class="mx-2" normalButton />
          <ButtonComp @click="$emit('close')" :disabled="loading" text-button="Cancelar" class-color="red"
            normal-button />
        </template>
      </ComunDialogComp>

    </v-form>

    <!-- fin modal Pregunta -->
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapGetters, mapMutations } from "vuex";
// import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import ComunDialogComp from '../../../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue';

export default {
  name: "TemaFormulario",
  components: {
    // BtnComp,
    ComunDialogComp,
    ButtonComp
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  data: () => ({
    datoLogin: sessionStorage,
    evento: null,
    test: false,
    datos: {},
    paramComponente: { id_submodulo: 22, id_modulo: 4 },

    unidad: {},
    formClase: {},

    rutaServer: API_URL,
    inhabilitarButton: false,

    filter: {},
    loading: false,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo electrónico es incorrecto";
        }
      },

      hora: (value) => {
        if (value < "00:01") {
          return "El formato de la hora ingresada es incorrecto";
        } else {
          if (value >= "23:59") {
            return "El formato de la hora ingresada es incorrecto";
          }
        }
      },
    },
  }),

  mounted() {
    this.LoadMain();

    console.log(this.parametros);

  },

  //computadas
  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.parametros.evento === "add" ? "Crear tema" : "Editar nombre del tema";
    },
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.LimpiarForm();
      }
    },
  },

  methods: {
    //  ------- MENSAJE DE SISTEMA  --------

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    soloNumeros(event) {
      var key = window.event ? event.which : event.keyCode;
      if (key < 48 || key > 57) {
        event.preventDefault();
      }
    },

    LoadMain() {
      console.log("load Main (UnidadForm)");
      console.log(`Evento: ${JSON.stringify(this.parametros)} `);
      this.LimpiarForm();

      this.unidad = this.parametros.unidad;
      this.formClase.id_tema = this.unidad.id;

      if (this.parametros.evento == "add") {
        //
      }

      if (this.parametros.evento == "edit") {
        this.EditItem(this.parametros.item);
      }

      if (this.parametros.evento == "view") {
        this.EditItem(this.parametros.item);
      }
    },

    async EditItem(items) {
      this.formClase = items;
      this.datos.id_usuario = sessionStorage.id;
    },

    // Guardar datos
    async SaveItem() {
      if (this.$refs.formdatos.validate() == false) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Debe ingresar todo los campos",
          tiempo: 5000,
        });
        return false;
      }
      this.loading = true;

      try {
        let res = "";

        if (this.parametros.evento == "add") {
          res = await axios.post(`/manager/clase/`, this.formClase);
          this.setEnviarMens({
            tipo: res.messageT,
            mensaje: `${res.message}`,
            tiempo: null,
          });
        }

        if (this.parametros.evento == "edit") {
          res = await axios.put(
            `/manager/clase/${this.formClase.id_clase}`,
            this.formClase
          );
        }

        this.setEnviarMens({
          tipo: `${res.data.messageT}`,
          mensaje: `${res.data.message}`,
          tiempo: 6000,
        });
        this.inhabilitarButton = false;
        this.loading = false;

        if (res.data.messageT == "S") {
          this.$emit("close");
        }
      } catch (error) {
        this.inhabilitarButton = false;
        //console.log(handleError(error))
        //console.log(error)
        this.loading = false;
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    ResetValidation() {
      this.$refs.formdatos.resetValidation();
    },

    CloseComp() {
      console.log("close componente (temaFomComp) ");
      this.estadoModalConfig = false;
      this.compName = null;
      this.$emit("close");
    },

    LimpiarForm() {
      //    num_documento:77889966, num_documento2:55887745,

      this.formClase = {
        id: null,
        id_clase: null,
        id_tema: null,
        nombre_clase: "",
        sesion_aprendizaje: "",
        ubicacion_repositorio: "",
        orden_clase: null,
        id_usuario: sessionStorage.id,
      };

      this.ResetValidation();
    },
  },
};
</script>
<style scoped></style>
